
































import { defineComponent } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BaseCheckbox",
  components: { BaseSpinner, BaseIcon },
  props: {
    checked: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    secondary: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  model: {
    event: "input",
    prop: "checked",
  },
  methods: {
    click() {
      (getElement(this.$refs.checkbox) as HTMLInputElement).click();
    },
  },
});
